import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import ReactStrapTable from 'components/reactStrapTable';
import { cellRendererCheck, dateFormate, currencyFormat, decimalFormat, dateOnly,cellRendererNumber } from 'utils/columns';
import useAxios from 'hooks/useAxios';
import DragDrop from 'components/DragDrop';
import Loader from 'components/Loader';
import FallourReasonsModal from '../components/FallourReasons';

let tableDataBackup = [],
    rowForEdit = {},
    updatedFields = {};

let modulename = "PharmacyReportsDetails";

let autoselectlist1 = [];
let numberlist = ['Est. WAC Retail Cost','Claim ID', 'Rx #', 'Dispensed Quantity', 'Days Supply', 'Co-pay', 'Plan Paid Amount','Retails Drug Cost', 'Est Non 340B Net Profit', 'Dispensing Fee', 'Est 340B Net Profit', 'Replenishment %', 'Replenishment Qty', 'Billing Model', 'Est. 340B Net Profit','Trued-Up Qty']
let currencylist = ['Co-pay', 'Plan Paid Amount', 'Total Paid', 'Retails Drug Cost', 'Est. Non 340B Net Profit', 'Est. 340B Net Profit', 'Est. WAC Retail Cost', 'Dispensing Fee','Trued-Up Cost']
let dateList = ['Written Date', 'Switch Date', 'Service Date', 'Claim Captured Date', 'Patient DOB', 'Replenishment Date', 'Date Rx Written', 'Date of Service','Trued-Up Date']
let hideColFilterlist = ["Total Paid","SCC", "Claim Type", "Claim Sub Type", "Replenishment Status", "Billing Model","Est. Non 340B Net Profit","Est. WAC Retail Cost","Replenishment PO #","Replenishment Date","Replenished Qty"];
let hideSortinglist = ["Total Paid","SCC", "Prescriber Name", "Claim Type", "Claim Sub Type", "Replenishment Status", "Billing Model","Est. Non 340B Net Profit","Est. WAC Retail Cost","Replenishment PO #","Replenishment Date","Replenished Qty"];


const PharmacyDetailsTable = (props) => {

    const {
        data,
        totalSize,
        onPageChange,
        filters,
        loading,
        slelectedExport,
        onSearchColumnFilters = () => '',
        AllExport,
        refetch,
        dateid,
        searchTerms,
        module,
        toggleSider,
        collapseSider
    } = props;
    const API = useAxios();
    tableDataBackup = data;

    const [tableData, setTableData] = useState(tableDataBackup);
    const [reset, setReset] = useState(false);
    const [claimID, setClaimID] = useState('');
    const [colFilters, setColFilters] = useState({});
    const [hasExportPermission, setHasExportPermission] = useState(false);
    const [isReasonOpen, setIsReasonOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const [columnSelect, setColumnSelect] = useState(false);
    const [hasDisabledSelectedCols, setHasDisabledSelectedCols] = useState(false);
    const [isPopUpOpen, setPopUpOpen] = useState(false);

    useEffect(() => {
        setTableData(data);
        tableDataBackup = data;
    }, [data]);

    const handleReason = (row) => {
        setIsReasonOpen(!isReasonOpen);
        setSelectedRow(row);
    };

    useEffect(() => {
        handleAutoColumns();
    }, []);

    const cellRendererReason = (row) => {

        const { reason } = row;
        if (reason != 'Non-Derived') {
            return (
                <span
                    className='cursor-pointer text-decoration-underline'
                    onClick={() => handleReason(row)}
                >
                    {reason}
                </span>
            );
        }
        return cellRendererCheck;

    };

    const togglePopUp = (rowData) => {

        setPopUpOpen(!isPopUpOpen);
        setSelectedRow(rowData);
    }

    const handleAutoColumns = async () => {
        autoselectlist1 = [];
        try {
            const result = await API.get(`CPConfig/ColumnSelector/autoselectcolumnslist/${modulename}`, {
                hasDefaultURL: true,
            });
            if (result.data) {
                if (result.data.length > 0) {
                    setHasDisabledSelectedCols(false);
                }
                else {
                    setHasDisabledSelectedCols(true);
                }
                for (var x in result.data) {
                    autoselectlist1.push({ "text": result.data[x].displayName, "dataField": result.data[x].fieldName });
                }
            }

        } catch (err) {

        }
    };

    const handleSelectColumns = () => {
        setColumnSelect(!columnSelect);
    }

    const addCol = (autoselectlist1) => {
        let columns = [];
        for (var x in autoselectlist1) {
            columns.push({
                dataField: autoselectlist1[x]?.dataField,
                text: autoselectlist1[x]?.text,
                cellRenderer: currencylist.includes(autoselectlist1[x]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[x]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[x]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
                show: autoselectlist1.length > 0 ? true : false,
                inputType: dateList.includes(autoselectlist1[x]?.text) ? "date" : numberlist.includes(autoselectlist1[x]?.text) ? "number" : "text",
                width: 160,
                hideColFilter: hideColFilterlist.includes(autoselectlist1[x]?.text) ? true : false,
                action: true,
                edit: false,
                sort: !hideSortinglist.includes(autoselectlist1[x]?.text) ? true : false,
            },)
        }
        return columns;
    }

    let maincol1 = [
        {
            dataField: 'options',
            text: 'Options',
            sort: false,
            width: 100,
            show: true,
            inputType: 'text',
            //cellRenderer: (rowData) => cellRenderEdit(rowData),
            action: true,

        },
        ...addCol(autoselectlist1)
    ]
    // {
    //     dataField: autoselectlist1[0]?.dataField,
    //     text: autoselectlist1[0]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[0]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[0]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[0]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > 0 ? true : false,
    //     inputType: dateList.includes(autoselectlist1[0]?.text) ? "date" : numberlist.includes(autoselectlist1[0]?.text) ? "number" : "text",
    //     width: 314,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[1]?.dataField,
    //     text: autoselectlist1[1]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[1]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[1]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[1]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [1] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[1]?.text) ? "date" : numberlist.includes(autoselectlist1[1]?.text) ? "number" : "text",
    //     width: 250,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[2]?.dataField,
    //     text: autoselectlist1[2]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[2]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[2]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[2]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [2] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[2]?.text) ? "date" : numberlist.includes(autoselectlist1[2]?.text) ? "number" : "text",
    //     width: 200,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[3]?.dataField,
    //     text: autoselectlist1[3]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[3]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[3]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[3]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [3] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[3]?.text) ? "date" : numberlist.includes(autoselectlist1[3]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[4]?.dataField,
    //     text: autoselectlist1[4]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[4]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[4]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[4]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [4] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[4]?.text) ? "date" : numberlist.includes(autoselectlist1[4]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[5]?.dataField,
    //     text: autoselectlist1[5]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[5]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[5]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[5]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [5] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[5]?.text) ? "date" : numberlist.includes(autoselectlist1[5]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[6]?.dataField,
    //     text: autoselectlist1[6]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[6]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[6]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[6]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [6] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[6]?.text) ? "date" : numberlist.includes(autoselectlist1[6]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[7]?.dataField,
    //     text: autoselectlist1[7]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[7]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[7]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[7]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [7] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[7]?.text) ? "date" : numberlist.includes(autoselectlist1[7]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[8]?.dataField,
    //     text: autoselectlist1[8]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[8]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[8]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[8]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [8] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[8]?.text) ? "date" : numberlist.includes(autoselectlist1[8]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[9]?.dataField,
    //     text: autoselectlist1[9]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[9]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[9]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[9]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [9] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[9]?.text) ? "date" : numberlist.includes(autoselectlist1[9]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[10]?.dataField,
    //     text: autoselectlist1[10]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[10]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[10]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[10]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [10] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[10]?.text) ? "date" : numberlist.includes(autoselectlist1[10]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[11]?.dataField,
    //     text: autoselectlist1[11]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[11]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[11]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[11]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [11] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[11]?.text) ? "date" : numberlist.includes(autoselectlist1[11]?.text) ? "number" : "text",
    //     width: 190,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[12]?.dataField,
    //     text: autoselectlist1[12]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[12]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[12]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[12]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [12] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[12]?.text) ? "date" : numberlist.includes(autoselectlist1[12]?.text) ? "number" : "text",
    //     width: 190,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[13]?.dataField,
    //     text: autoselectlist1[13]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[13]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[13]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[13]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [13] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[13]?.text) ? "date" : numberlist.includes(autoselectlist1[13]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[14]?.dataField,
    //     text: autoselectlist1[14]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[14]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[14]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[14]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [14] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[14]?.text) ? "date" : numberlist.includes(autoselectlist1[14]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[15]?.dataField,
    //     text: autoselectlist1[15]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[15]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[15]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[15]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [15] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[15]?.text) ? "date" : numberlist.includes(autoselectlist1[15]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[16]?.dataField,
    //     text: autoselectlist1[16]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[16]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[16]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[16]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [16] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[16]?.text) ? "date" : numberlist.includes(autoselectlist1[16]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[17]?.dataField,
    //     text: autoselectlist1[17]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[17]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[17]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[17]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [17] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[17]?.text) ? "date" : numberlist.includes(autoselectlist1[17]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[17]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[17]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[18]?.dataField,
    //     text: autoselectlist1[18]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[18]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[18]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[18]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [18] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[18]?.text) ? "date" : numberlist.includes(autoselectlist1[18]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[18]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[18]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[19]?.dataField,
    //     text: autoselectlist1[19]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[19]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[19]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[19]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [19] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[19]?.text) ? "date" : numberlist.includes(autoselectlist1[19]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[19]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[19]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[20]?.dataField,
    //     text: autoselectlist1[20]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[20]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[20]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[20]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [20] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[20]?.text) ? "date" : numberlist.includes(autoselectlist1[20]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[20]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[20]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[21]?.dataField,
    //     text: autoselectlist1[21]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[21]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[21]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[21]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [21] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[21]?.text) ? "date" : numberlist.includes(autoselectlist1[21]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[21]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[21]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[22]?.dataField,
    //     text: autoselectlist1[22]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[22]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[22]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[22]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [22] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[22]?.text) ? "date" : numberlist.includes(autoselectlist1[22]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[22]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[22]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[23]?.dataField,
    //     text: autoselectlist1[23]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[23]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[23]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[23]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [23] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[23]?.text) ? "date" : numberlist.includes(autoselectlist1[23]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[23]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[23]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[24]?.dataField,
    //     text: autoselectlist1[24]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[24]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[24]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[24]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [24] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[24]?.text) ? "date" : numberlist.includes(autoselectlist1[24]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[24]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[24]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[25]?.dataField,
    //     text: autoselectlist1[25]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[25]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[25]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[25]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [25] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[25]?.text) ? "date" : numberlist.includes(autoselectlist1[25]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[25]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[25]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[26]?.dataField,
    //     text: autoselectlist1[26]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[26]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[26]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[26]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [26] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[26]?.text) ? "date" : numberlist.includes(autoselectlist1[26]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[26]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[26]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[27]?.dataField,
    //     text: autoselectlist1[27]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[27]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[27]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[27]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [27] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[27]?.text) ? "date" : numberlist.includes(autoselectlist1[27]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[27]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[27]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[28]?.dataField,
    //     text: autoselectlist1[28]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[28]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[28]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[28]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [28] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[28]?.text) ? "date" : numberlist.includes(autoselectlist1[28]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[28]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[28]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[29]?.dataField,
    //     text: autoselectlist1[29]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[29]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[29]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[29]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [29] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[29]?.text) ? "date" : numberlist.includes(autoselectlist1[29]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[29]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[29]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[30]?.dataField,
    //     text: autoselectlist1[30]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[30]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[30]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[30]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [30] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[30]?.text) ? "date" : numberlist.includes(autoselectlist1[30]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[30]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[30]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[31]?.dataField,
    //     text: autoselectlist1[31]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[31]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[31]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[31]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [31] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[31]?.text) ? "date" : numberlist.includes(autoselectlist1[31]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[31]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[31]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[32]?.dataField,
    //     text: autoselectlist1[32]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[32]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[32]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[32]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [32] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[5]?.text) ? "date" : numberlist.includes(autoselectlist1[32]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[32]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[32]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[33]?.dataField,
    //     text: autoselectlist1[33]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[33]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[33]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[33]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [33] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[33]?.text) ? "date" : numberlist.includes(autoselectlist1[33]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[33]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[33]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[34]?.dataField,
    //     text: autoselectlist1[34]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[34]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[34]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[34]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [34] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[34]?.text) ? "date" : numberlist.includes(autoselectlist1[34]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[34]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[34]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[35]?.dataField,
    //     text: autoselectlist1[35]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[35]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[35]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[35]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [35] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[35]?.text) ? "date" : numberlist.includes(autoselectlist1[35]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[35]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[35]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[36]?.dataField,
    //     text: autoselectlist1[36]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[36]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[36]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[36]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [36] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[36]?.text) ? "date" : numberlist.includes(autoselectlist1[36]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[36]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[36]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[37]?.dataField,
    //     text: autoselectlist1[37]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[37]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[37]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[37]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [37] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[37]?.text) ? "date" : numberlist.includes(autoselectlist1[37]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[37]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[37]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[38]?.dataField,
    //     text: autoselectlist1[38]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[38]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[38]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[38]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [38] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[38]?.text) ? "date" : numberlist.includes(autoselectlist1[38]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[38]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[38]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[39]?.dataField,
    //     text: autoselectlist1[39]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[39]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[39]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[39]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [39] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[39]?.text) ? "date" : numberlist.includes(autoselectlist1[39]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[39]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[39]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[40]?.dataField,
    //     text: autoselectlist1[40]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[40]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[40]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[40]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [40] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[40]?.text) ? "date" : numberlist.includes(autoselectlist1[40]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[40]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[40]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[41]?.dataField,
    //     text: autoselectlist1[41]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[41]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[41]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[41]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [41] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[41]?.text) ? "date" : numberlist.includes(autoselectlist1[41]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[41]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[41]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[42]?.dataField,
    //     text: autoselectlist1[42]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[42]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[42]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[42]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [42] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[42]?.text) ? "date" : numberlist.includes(autoselectlist1[42]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[42]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[42]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[43]?.dataField,
    //     text: autoselectlist1[43]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[43]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[43]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[43]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [43] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[43]?.text) ? "date" : numberlist.includes(autoselectlist1[43]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[43]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[43]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[44]?.dataField,
    //     text: autoselectlist1[44]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[44]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[44]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[44]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [44] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[44]?.text) ? "date" : numberlist.includes(autoselectlist1[44]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[44]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[44]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[45]?.dataField,
    //     text: autoselectlist1[45]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[45]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[45]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[45]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [45] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[45]?.text) ? "date" : numberlist.includes(autoselectlist1[45]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[45]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[45]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[46]?.dataField,
    //     text: autoselectlist1[46]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[46]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[46]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[46]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [46] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[46]?.text) ? "date" : numberlist.includes(autoselectlist1[46]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[46]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[46]?.text) ? true : false,
    // },
    // {
    //     dataField: autoselectlist1[47]?.dataField,
    //     text: autoselectlist1[47]?.text,
    //     cellRenderer: currencylist.includes(autoselectlist1[47]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[47]?.text) ? (rowData, col) => dateOnly(rowData[col.dataField]) : autoselectlist1[47]?.text == "Reason" ? (rowData) => cellRendererReason(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     show: autoselectlist1.length > [47] ? true : false,
    //     inputType: dateList.includes(autoselectlist1[47]?.text) ? "date" : numberlist.includes(autoselectlist1[47]?.text) ? "number" : "text",
    //     width: 180,
    //     hideColFilter: hideColFilterlist.includes(autoselectlist1[47]?.text) ? true : false,
    //     action: true,
    //     edit: false,
    //     sort: !hideColFilterlist.includes(autoselectlist1[47]?.text) ? true : false,
    // },

    // ];

    const mainCol = [{
        dataField: 'options',
        text: 'Options',
        width: 100,
        show: true,
        hideColFilter: true,
        action: true
    },
    {
        dataField: 'coveredEntityName',
        text: 'Covered Entity/OPAID',
        sort: true,
        width: 410,
        show: true,
        inputType: 'text',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'pharmacyName',
        text: 'Pharmacy Name',
        sort: true,
        width: 340,
        show: true,
        inputType: 'text',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'pharmacyNPI',
        text: 'Pharmacy NABP/NPI',
        sort: true,
        width: 230,
        show: true,
        inputType: 'text',
        hideColFilterlist: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'transactionCode',
        text: 'Transaction Code',
        sort: true,
        width: 210,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'cardHolderId',
        text: 'Insurance Member ID',
        sort: true,
        width: 180,
        show: true,
        inputType: 'text',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'bin',
        text: 'BIN #',
        sort: true,
        width: 90,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'pcn',
        text: 'PCN #',
        sort: true,
        width: 90,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'groupNumber',
        text: 'Group #',
        sort: true,
        width: 90,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'secondaryBIN',
        text: 'Secondary BIN #',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'secondaryPCN',
        text: 'Secondary PCN #',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'secondaryGroupNumber',
        text: 'Secondary Group #',
        sort: true,
        width: 240,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'occ',
        text: 'OCC',
        sort: true,
        width: 200,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'submissionClarificationCode',
        text: 'SCC',
        sort: false,
        width: 200,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'rxNumber',
        text: 'Prescription #',
        sort: true,
        width: 120,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'claimID',
        text: 'Claim ID',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'refillNumber',
        text: 'Refill #',
        sort: true,
        width: 170,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'switchDate',
        text: 'Switch Date',
        sort: true,
        width: 140,
        show: true,
        inputType: 'date',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => dateOnly(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'dateRXWritten',
        text: 'Date Rx Written',
        sort: true,
        width: 140,
        show: true,
        inputType: 'date',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => dateOnly(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'dateOfService',
        text: 'Date of Service',
        sort: true,
        width: 140,
        show: true,
        inputType: 'date',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => dateOnly(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'createdDate',
        text: 'Claim Captured Date',
        sort: true,
        width: 140,
        show: true,
        inputType: 'date',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => dateOnly(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'patientFirstName',
        text: 'Patient First Name',
        sort: true,
        width: 210,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'patientLastName',
        text: 'Patient Last Name',
        sort: true,
        width: 210,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'patientGender',
        text: 'Patient Gender',
        sort: true,
        width: 190,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'patientDOB',
        text: 'Patient DOB',
        sort: true,
        width: 150,
        show: true,
        inputType: 'date',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => dateOnly(rowData[col.dataField]),
        showColumn: true
    },

    {
        dataField: 'prescriberName',
        text: 'Prescriber Name',
        sort: false,
        width: 180,
        show: true,
        inputType: 'text',
        //hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'prescriberNPI',
        text: 'Prescriber NPI',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'ndc',
        text: 'NDC',
        sort: true,
        width: 150,
        show: true,
        inputType: 'text',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'drugName',
        text: 'Drug Name',
        sort: true,
        width: 260,
        show: true,
        inputType: 'text',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'manufacturerName',
        text: 'Mfg. Name',
        sort: true,
        width: 160,
        show: true,
        inputType: 'text',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'brandOrGenericFlag',
        text: 'Drug Indicator',
        sort: true,
        width: 150,
        show: true,
        inputType: 'text',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'metricQuantity',
        text: 'Dispensed Quantity',
        sort: true,
        width: 120,
        show: true,
        inputType: 'number',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => decimalFormat(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'daysSupply',
        text: 'Days Supply',
        sort: true,
        width: 160,
        show: true,
        inputType: 'number',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'coPay',
        text: 'Co-pay',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'planPaidAmount',
        text: 'Plan Paid Amount',
        sort: true,
        width: 180,
        show: true,
        inputType: 'number',
        // hideColFilter: false,
        cellRenderer: (row) => currencyFormat(row.planPaidAmount),
    },
    {
        dataField: 'totalPay',
        text: 'Total Paid',
        sort: false,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'estWACRetailCost',
        text: 'Est. WAC Retail Cost',
        sort: false,
        width: 180,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'estNon340BNetProfit', 
        text: 'Est. Non 340B Net Profit',
        sort: false,
        width: 180,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (row) => currencyFormat(row.estNon340BNetProfit),
    },
    {
        dataField: 'customDispensingFee',
        text: 'Dispensing Fee',
        sort: true,
        width: 180,
        show: true,
        inputType: 'number',
        // hideColFilter: false,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'est340BNetProfit', 
        text: 'Est. 340B Net Profit',
        sort: true,
        width: 180,
        show: true,
        inputType: 'number',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'truedUpDate', 
        text: 'Trued-Up Date',
        sort: true,
        width: 180,
        show: true,
        inputType: 'date',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => dateOnly(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'truedUpUnits', 
        text: 'Trued-Up Qty',
        sort: true,
        width: 180,
        show: true,
        inputType: 'number',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererNumber(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'truedUpCost', 
        text: 'Trued-Up Cost',
        sort: true,
        width: 180,
        show: true,
        inputType: 'number',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'claimType',
        text: 'Claim Type',
        sort: false,
        width: 120,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'claimSubType',
        text: 'Claim Sub Type',
        sort: false,
        width: 120,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'falloutReason',
        text: 'Fallout Reason',
        sort: true,
        width: 240,
        show: true,
        inputType: 'text',
        // hideColFilter: true,
        cellRenderer: (rowData) => rowData.claimType == 'Non-Derived' ? cellRendererCheck(rowData.reason) : cellRendererReason(rowData),
        showColumn: true
    },
    {
        dataField: 'replenishmentStatus',
        text: 'Replenishment Status',
        sort: false,
        width: 170,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'replenishmentPercentage',
        text: 'Replenishment %',
        sort: true,
        width: 150,
        show: true,
        inputType: 'number',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'replenishmentQty',
        text: 'Replenished Qty',
        sort: false,
        width: 150,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'replenishmentDate',
        text: 'Replenishment Date',
        sort: false,
        width: 150,
        show: true,
        inputType: 'date',
        hideColFilter: true,
        cellRenderer: (rowData, col) => dateOnly(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'replenishmentPONumber',
        text: 'Replenishment PO #',
        sort: false,
        width: 160,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'billingModel',
        text: 'Billing Model',
        sort: false,
        width: 145,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },

    ];

    const onHandleSort = (filter, hasColFilter) => {

        filter.DateRangeId = dateid ? dateid : searchTerms.dateRangeID;
        if (filter.dateRangeID == 7) {
            filter.StartDate = searchTerms.startDate;
            filter.EndDate = searchTerms.endDate == '' ? new Date() : searchTerms.endDate;
        }
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            filter.DetailRow = [];
            onPageChange(filter);
        }
    };

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {

        filter.DateRangeId = dateid ? dateid : searchTerms.dateRangeID;
        if (filter.dateRangeID == 7) {
            filter.StartDate = searchTerms.startDate;
            filter.EndDate = searchTerms.endDate == '' ? new Date() : searchTerms.endDate;
        }
        if (hasColFilter) {
            const colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        onPageChange(filter);
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {

        filter.DateRangeId = dateid ? dateid : searchTerms.dateRangeID;
        filter.StartDate = searchTerms.startDate;
        filter.EndDate = searchTerms.endDate == '' ? new Date() : searchTerms.endDate;
        if (hasColFilter) {
            const colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            onPageChange(filter);
        }
    };

    const handleSearchColumnFilters = (colFilter) => {
        onSearchColumnFilters(colFilter)
    };

    const handleFilterCancel = () => {
        refetch();
    };

    return (
        <>
            {loading && <Loader opacity={0.01} colour='black' />}
            {/* <div
                className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
            > */}
            <div
                className="table-card scroll-table position-relative border-0 rounded pt-0"
                fixed-height={data.length > 0 ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}` : "default"}
            >
                <ReactStrapTable
                    id='pharmacy-details-table'
                    height={550}
                    fixedColumn
                    width={1200}
                    reset={reset}
                    hasPagination
                    data={tableData}
                    columns={autoselectlist1.length > 0 ? maincol1 : mainCol}
                    // onExport={onExport}
                    AllExport={AllExport}
                    filters={filters}
                    totalRecords={totalSize}
                    pageSize={filters.pageSize}
                    currentPage={filters.currentPage}
                    handleSort={onHandleSort}
                    onPageChange={onHandlePageChange}
                    onPageSizeChange={onPageSizeChange}
                    onFilterCancel={handleFilterCancel}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    slelectedExport={slelectedExport}
                    hasExportPermission1={true}
                    hasColselect={true}
                    onSelectColumns={handleSelectColumns}
                    hasExportPermission={hasExportPermission}
                    hasDisabledSelectedCols={hasDisabledSelectedCols}
                    toggleSider={toggleSider}
                    collapseSider={collapseSider}
                    autoselectlist1={autoselectlist1}
                />
                {/* <FallourReasonsModal isOpen={isReasonOpen} toggle={handleReason} row={selectedRow} /> */}

                <FallourReasonsModal isOpen={isReasonOpen} toggle={handleReason} row={selectedRow} />
                <Modal
                    isOpen={isPopUpOpen}
                    toggle={togglePopUp}
                    size='xl'
                    className='xl'
                >
                </Modal>
                <Modal
                    isOpen={columnSelect}
                    toggle={handleSelectColumns}
                    size='lg'
                    className='lg'
                >
                    <ModalHeader toggle={handleSelectColumns}>
                        Column Selector
                    </ModalHeader>
                    <ModalBody>
                        <DragDrop cancalcolselect={handleSelectColumns} refetch={handleFilterCancel} reloadautocolumn={handleAutoColumns} module={modulename} />
                    </ModalBody>
                </Modal>

            </div>
        </>

    );
};
export default PharmacyDetailsTable;
